












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({components: {Toggle}})
export default class GTAdvisory extends Vue {
  @Prop() readonly group!: any;

  @Watch('section1', {immediate: false, deep: true})
  onData0() {
    this.onData();
  }
  @Watch('section2', {immediate: false, deep: true})
  onData1() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get section1(): any {
    return dokument.getItems(this.group.Id)[1];
  }

  get section2(): any {
    return dokument.getItems(this.group.Id)[2];
  }

  get hidden(): boolean {
    return this.section1.Hidden && this.section2.Hidden;
  }
}
